const AppSettings = {
  appKey: "idauto_reporte_",
  reportKey: "idauto_compra_",
  documentType: "idauto_reporte_expediente",
  tenant: "idar",
  cookieExpirationDays: 600,
  cookieName: "id-auto-report-allow-cookies",
  recatchaKey: "6LcTqjYpAAAAAI_BgPkd2Adq4QQ3kOAfI3lCQEzo", // LOCAL TEST KEY
  // recatchaKey: '6LcukOIZAAAAAKb94J_swPnEtCVMXYTpPaOPU7Lv', // PROD KEY
  ticketName: "id-auto-report-token",
  modalContainerId: "OIZAAAAAKb94JnEt",
  priceReport: 6500,
  currentPendingReportToken: "kOIRpTOv45v2vIPning6Lsm",
  cacheUnfinishReportToken: "pTOv4ikOIRng6Lsmv2vIPn",
  paginationSize: 10,
};
export default AppSettings;
